<template>
  <div class="flex xs12 md12 w-table">
    <vuestic-widget id="dategridPayOrder">
      <div class="va-row">
          <div class="flex md6 batch-upload-tip">
            {{ "t.batchUploadLogs" | translate }}
          </div>
          <div class="flex md6 text-right">
            <button class="btn btn-primary btn-micro mr-2" @click="upload">
              <div class="btn-with-icon-content">
                {{ "basic.button.upload" | translate }}
              </div>
            </button>
            <button class="btn btn-info btn-micro" @click="downloadTemplate">
              <div class="btn-with-icon-content">
                {{ "basic.button.template" | translate }}
              </div>
            </button>
          </div>
      </div>
      <div class="table-responsive mt-2" id="batchUpload">
        <table class="table table-striped">
          <thead>
            <tr>
              <th v-for="(item, index) in tableHeaderList" :key="index">
                {{ item.label | translate }}
              </th>
            </tr>
          </thead>
          <tbody v-if="list">
            <tr v-for="(item, index) in list" :key="index">
              <td> {{ item.id }} </td>
              <td>{{ item.original_name }}</td>
              <td> {{ item.create_time }} </td>
              <td> {{ item.update_time || "N/A" }} </td>
              <!-- 0 Processing，1 Complated -->
              <td> {{ submitStatusText(item.status) }} </td>
              <td>
                <a v-if="item.status==='3' || item.status==='2'" href="javascript:void(0);" @click="downloadFile(item)"><i class="el-icon-download"></i>{{ $t('t.downloadFile') }}</a>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11" v-text="noData"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="block" v-if="isMobile === 'pc'">
        <pagination
          v-show="total > 0"
          :total="total"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :page.sync="page"
          :limit.sync="limit"
          @pagination="orderData"
        />
      </div>
      <div class="block" v-else>
        <pagination
          v-show="total > 0"
          :total="total"
          layout="total, prev, pager, next"
          background
          :page.sync="page"
          :limit.sync="limit"
          @pagination="orderData"
        />
      </div> -->
    </vuestic-widget>
    <vuestic-modal :show.sync="batchUploadshow"
                   ref="batchUpload"
                   :okText="'modal.confirm2' | translate"
                   style="height: 100%;width:60vw;"
                   :okClass="'btn btn-primary btn-micro'"
                   :cancelClass="'btn btn-secondary btn-micro'"
                   :cancelText="'modal.cancel2' | translate"
                   alignModal=""
                   >
      <div slot="title">{{ $t("menu.batchUpload") }}</div>
      <vuestic-file-upload type="single" v-model="excelfile" fileTypes="xlsx"></vuestic-file-upload>
    </vuestic-modal>
  </div>
</template>
<script>
import vuesticFileUpload from "@/vuestic-theme/vuestic-components/vuestic-file-upload/VuesticFileUpload"
import Pagination from "@/components/Pagination";
import { request } from "@/utils/utils.js";

export default {
  name: "PaymentOrderDetail",
  components: {
    Pagination,
    vuesticFileUpload,
  },
  data() {
    return {
      list: [], // 请求回来填充表格的数据
      total: 0, // 数据总条数
      page: 1, // 默认显示第1页
      limit: 10, // 默认一次显示10条数据
      noData: this.$t("t.noDataNoOrder"),
      batchUploadshow: true,
      excelfile: []
    }
  },
  mounted() {
    this.initBatchUpload();
    this.initMethod();
  },
  computed: {
    isMobile: function () {
      if (document.body.clientWidth && document.body.clientWidth < 750) {
        return "mobile";
      }
      return "pc";
    },
    tableHeaderList () {
      return [
        { label: "t.id", key: "id", id: 0 },
        { label: "t.fileName", key: "fileName", id: 1 },
        { label: "t.submitTime", key: "submitTime", id: 2 },
        { label: "t.upDateDate", key: "updateDate", id: 3 },
        { label: "t.submitStatus", key: "submitStatus", id: 4 },
        { label: "t.action", key: "action", id: 5 },
      ]
    }
  },
  methods: {
    orderData() {
      let start = this.page;
      let end = this.limit;
      let token = localStorage.getItem("Authorization");
    },
    downloadFile(item) {
      window.location.href = item.target_name;
    },
    upload() {
      this.$refs.batchUpload.open()
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    downloadTemplate() {
      this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
      let token = localStorage.getItem("Authorization");
      request({
        method: "post",
        url: `api/dashboard/waybill/download-template?access_token=${token}`,
        data: {},
        responseType: "blob"
      })
        .then((res) => {
          this.searching.close();
          let blob = new Blob([res.data], { type: "application/x-xls" }); //res--后台返回的文件流
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Template.xlsx";
          link.click();
        })
        .catch((err) => {
          this.searching.close();
        });
    },
    initBatchUpload() {
      this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
      let token = localStorage.getItem("Authorization");
      request({
        method: "post",
        url: `api/dashboard/waybill/upload-history?access_token=${token}`,
        data: {},
      })
        .then((res) => {
          if (!res) {
            this.searching.close();
            return;
          }
          if (res.data.code == 10000) {
            this.list = res.data.data;
            this.total = res.data.data.length;
            setTimeout(() => {
              this.searching.close();
            }, 800);
          } else if (res.data.code == 20000) {
            this.list = [];
            this.total = 0;
            this.noData = this.$t("t.noData");
            setTimeout(() => {
              this.searching.close();
            }, 200);
            return;
          }
        })
        .catch((err) => {
          this.searching.close();
        });
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    initMethod() {
      const that = this;
      that.$refs.batchUpload.ok = () => {
        if (that.excelfile.length == 0) {
          that.showToast('Please select at least one', {
            icon: "fa-exclamation-circle",
            position: "bottom-center",
            duration: "3000",
            fullWidth: true
          });
          return
        }
        let token = localStorage.getItem("Authorization");
        let formdata = new FormData();
        formdata.append("files", that.excelfile[that.excelfile.length-1])
        that.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
        request({
          method: "post",
          url: `api/dashboard/waybill/upload?access_token=${token}`,
          data: formdata,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then((res) => {
            if (res.data.code == 10000) {
              that.excelfile = [];
              that.searching.close();
              that.$refs.batchUpload.close()
              that.initBatchUpload();
              that.showToast("Success", {
                icon: "fa-star-o",
                position: "top-center",
                duration: 2500,
                fullWidth: false,
              });
            } else {
              that.searching.close();
              that.showToast(res.data.msg, {
                icon: "fa-exclamation-circle",
                position: "bottom-center",
                duration: "3000",
                fullWidth: true
              });
            }
          })
          .catch((err) => {
            that.searching.close();
          });
      }
      that.$refs.batchUpload.cancel = () => { that.excelfile = [];that.$refs.batchUpload.close() }
    },
    // 0 Processing 1 ALL Success 2 Partial Success 3 Failure
    submitStatusText(value) {
      if (value == 3) return this.$t('statusLabel.failure')
      if (value == 2) return this.$t('statusLabel.partialSuccess')
      if (value == 1) return this.$t('statusLabel.allSuccess')
      if (value == 0) return this.$t('statusLabel.processing')
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
.batch-upload-tip {
  line-height: 30px;
}
#batchUpload .table thead th {
  width: 300px;
}
</style>
